<sm-toolbar>
  <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
  </p-button>
</sm-toolbar>
<p-table class="p-datatable-gridlines" [value]="rows">
  <ng-template pTemplate="header">
    <tr>
      <th width="19%">Thema&#47;Inhalt</th>
      <th width="19%">Fehlende Schüler</th>
      <th width="19%">Datum&#47;Belehrender</th>
      <th width="19%">Nachbelehrung</th>
      <th width="19%">Datum&#47;Belehrender</th>
      <th width="5%"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-index="rowIndex">
    <tr [pSelectableRow]="row">
      @if (index >= rowCount) {
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select class="width100p" id="topic" [filter]=true [resetFilterOnHide]="true" [autofocusFilter]="true" appendTo="body" selectionMode="multiple" [options]="instructionOptions" [ngModel]="row.topic" (ngModelChange)="changeTopic($event, row)">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{row.topic}}
            </ng-template>
          </p-cellEditor>
        </td>
      }
      @if (index < rowCount) {
        <td>
          {{row.topic}}
        </td>
      }
      @if (index >= rowCount) {
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-multiSelect class="width100p" id="missingPupilIds" appendTo="body" selectionMode="multiple" [resetFilterOnHide]="true" [autofocusFilter]="true" [options]="pupilsGui" [ngModel]="row.missingPupilIds" (ngModelChange)="changeMissing($event, row)">
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="output">
              {{row.missingPupilIds != null ? getPupilList(row.missingPupilIds).join(', ') : ''}}
            </ng-template>
          </p-cellEditor>
        </td>
      }
      @if (index < rowCount) {
        <td>
          {{row.missingPupilIds != null ? getPupilList(row.missingPupilIds).join(', ') : ''}}
        </td>
      }
      <td>
        {{ row.date | date:'dd.MM.yyyy' }} - {{ getTeacherByUser(row.instructedBy) }}
      </td>
      @if (secondInstructions.length == 0 || secondInstructions.indexOf(index) == -1) {
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select class="width100p" id="secondTopic" selectionMode="multiple" [options]="instructionOptions" [ngModel]="row.secondTopic" (ngModelChange)="changeSecondTopic($event, row)">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{row.secondTopic}}
            </ng-template>
          </p-cellEditor>
        </td>
      }
      @if (secondInstructions.length > 0 && secondInstructions.indexOf(index) != -1) {
        <td>
          {{row.secondTopic}}
        </td>
      }
      @if (row.secondDate != null) {
        <td>
          {{ row.secondDate | date:'dd.MM.yyyy' }} - {{getTeacherByUser(row.secondInstructedBy)}}
        </td>
      }
      @if (row.secondDate == null) {
        <td>
          {{ row.secondDate | date:'dd.MM.yyyy' }}
        </td>
      }
      <td pEditableColumn>
        @if (index >= rowCount) {
          <button pButton class="p-button-text" icon="fas fa-trash" (click)="removeRow(row)">
          </button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
@if (inited) {
  <sm-toolbar >
    <p-button icon="fas fa-plus" label="Neue Zeile" (onClick)="addRow()">
    </p-button>
  </sm-toolbar>
}
